import axios, { AxiosError } from "axios";

export function handleAxiosError(error: unknown): { message: string; status?: number } {
  if (axios.isAxiosError(error)) {
    const axiosError = error;
    if (axiosError.response) {
      const { status, statusText } = axiosError.response;
      return {
        message: `Error: ${status} - ${statusText}`,
        status
      };
    }
    return { message: axiosError.message };
  }
  return { message: "Unknown error occurred" };
}
